/**
 * @module support/store
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/*tslint:disable:max-file-line-count*/
/* tslint:disable:no-any */ // We need to be able to allow developers send any payload the want
import { EventEmitter, Injectable } from '@angular/core';
import { ContentProviderService } from '@core/aem/services/content-provider.service'; // @TODO remove
import {
  throwError as observableThrowError,
  Observable,
  Subject,
  of as observableOf,
  Subscriber,
} from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { API_MAP } from '@core/api/proxies/common-api-endpoints';
import { ASSISTED_API_MAP } from '@core/api/proxies/assisted-api-endpoints';
import { ApiGatewayService } from '@core/api/services/api-gateway-service';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {
  STORE_OPS_CONSTANTS,
  SET_STORE_ADDRESS_CONSTANTS,
} from '@experience/store-operations/components/store-ops.constants';
import {
  StoreData,
  StoreContentData,
  ClosePosTill,
  FormControlObject,
  Terminals,
  ClosePOSTillData,
  PosConfirmation,
  POSCashError,
  MobilityTill,
  ConfirmationData,
  CloseMobilityTill,
} from '@experience/store-operations/interfaces/store-ops.interface';
import { OpenPOSTillData } from '@experience/repdash/interfaces/customer-profile.interface';
import {
  AmountModel,
  Till,
  CloseTill,
  Capability,
  AddressValidationRequest,
} from '@experience/store-operations/interfaces/store-ops.interface';
import { SelectItem } from 'primeng/api';
import moment from 'moment';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { CONTENT_ENDPOINT } from '@core/aem/content-endpoints';
import { KeyValueMap } from '@support/shared/interfaces/key-value-map.interface';
import { CommonApiService } from '@support/shared/services/common-api/common-api.service';
import { ObjectInterface } from '@support/api/common/api-response.interface';
import { APIError } from '@support/api/common/error.interface';
import { HybridCashDrawerResponse } from '@support/api/proxies/responses/api-2072.interface';
import { SerializationResponse } from '@support/api/proxies/responses/api-2149.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { AddressValidationResponse } from '@support/api/proxies/responses/api-2004.interface';
import { GetTempStoreAddressResponse } from '@support/api/proxies/responses/api-2717.interface';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
// AOP,
import { TmoButton } from '@support/shared/widgets/interfaces/button.interface';
import { Wove } from 'aspect.js/';
import { TEXT_CONSTANTS } from '@support/shared/constants/device.constants';

@Wove({ moduleName: STORE_OPS_CONSTANTS.STORE_OPERATIONS_MODULE })
@Injectable({
  providedIn: 'root',
})
export class StoreService {
  public storeOpsTitle: string;
  public type: string;
  public storeOptPOSTillData: Object;
  public openStoreClicked: Subject<boolean>;
  // public closePosTillData: Object;
  public payLoadData: ClosePosTill;
  public payLoadMobilityData: CloseMobilityTill;
  public openPOsTillObject: Object;
  public tillDataObject: Object;

  // @TODO Getting from localStorgae instead of stateStore to unblock dev testing
  // public macAddress: string = this.stateStoreUtilsService.getMacAddress();
  public storeDetails: StoreData;
  public storeContentData: StoreContentData;
  public cashError: boolean;
  public confirmationData: OpenPOSTillData;
  public storeOperationSelected: string;
  public amountModel: AmountModel;
  public isRedirect: boolean;
  public openCloseTillPayLoad: CloseTill;
  public closeTillPayLoad: CloseTill;
  public formObject: FormControlObject;
  public islocationTypeMobileTruck: boolean;
  /**
   * Array to store opened tills
   */
  public openedTills: Till[];
  /**
   * Array to store closed tills
   */
  public closedTills: Till[];
  // public corporateRefunds: string[];

  public storeOpsData: StoreData;
  public storeDataChangeNotifier: EventEmitter<Object>;
  public storeRISStatusUpdateNotifier: EventEmitter<Object>;
  private terminalData: Terminals;
  private mobilityTillData: MobilityTill[];
  private isMobilityTillOpen: boolean;
  private mobilityTillOpenData: ConfirmationData;
  private corporateRefunds: string[];
  private closePOSTillData: ClosePOSTillData;
  private overshortCash: number;
  private overshortRefunds: number;
  private inBalance: boolean;
  private cashVariance: boolean;
  private refundVariance: boolean;
  private outofBalanceCount: number;
  private storeOpenDateTime: string;
  private posCashErrorObject: POSCashError;
  private posTillOpenConfirmationData: ConfirmationData;
  public openStoreNav: boolean = false;
  public setStoreViewChangeNotifier: EventEmitter<Object>;
  /**
   *  address validation API response
   */
  public suggestedAddress: AddressValidationResponse;
  public setAddressFormData: AddressValidationRequest;

  /**
   *  TMO Button interface object for cancel Button CTA
   */
  public cancelBtn: TmoButton;

  /**
   *  TMO Button interface object for continue Button CTA
   */
  public continueBtn: TmoButton;
  public tillType: string;

  /**
   * to Unscribe the api calls
   */
  private ngUnsubscribe: Subject<void>;

  /**
   * Cash drawers available
   */
  private networkCashDrawers: string[];
  /**
   * Store capabilities
   */
  private storeCapabilities: object;
  public storeDetailsRequested: Subject<boolean>;

  constructor(
    private stateStoreUtilsService: StateStoreUtilsService,
    private contentProviderService: ContentProviderService,
    private router: Router,
    private apiGateway: ApiGatewayService,
    private commonApiService: CommonApiService,
    private featureToggleUtilService: FeatureToggleUtilService,
    private objectService: ObjectService
  ) {
    this.corporateRefunds = [];
    this.networkCashDrawers = [];
    this.storeCapabilities = {};
    this.closePOSTillData = { cash: 0, totalCorporateRefunds: 0 };
    this.formObject = {};
    this.storeDataChangeNotifier = new EventEmitter();
    this.setStoreViewChangeNotifier = new EventEmitter();
    this.storeRISStatusUpdateNotifier = new EventEmitter();
    this.storeOpsTitle = '';
    this.outofBalanceCount = 0;
    this.openStoreClicked = new Subject<boolean>();
    this.cancelBtn = {
      id: SET_STORE_ADDRESS_CONSTANTS.ADDRESS_CANCEL_BUTTON,
      name: SET_STORE_ADDRESS_CONSTANTS.ADDRESS_CANCEL_BUTTON,
      class: SET_STORE_ADDRESS_CONSTANTS.BUTTON_SECONDARY_CLASS,
      type: SET_STORE_ADDRESS_CONSTANTS.BUTTON_TYPE_SECONDARY,
    };

    this.continueBtn = {
      id: SET_STORE_ADDRESS_CONSTANTS.ADDRESS_CONTINUE_BUTTON,
      name: SET_STORE_ADDRESS_CONSTANTS.ADDRESS_CONTINUE_BUTTON,
      class: SET_STORE_ADDRESS_CONSTANTS.BUTTON_PRIMARY_CLASS,
      type: SET_STORE_ADDRESS_CONSTANTS.BUTTON_TYPE_PRIMARY,
    };
    this.storeDetailsRequested = new Subject<boolean>();
    this.ngUnsubscribe = new Subject<void>();
  }

  /**
   * Get formObject
   * @returns FormControlObject
   */
  public getFormObject(): FormControlObject {
    return this.formObject;
  }
  public setFormObject(obj: FormControlObject): void {
    this.formObject = obj;
  }

  /**
   * Get Store Ops Title data
   * @returns string
   */
  public getStoreOpsTitle(): string {
    return this.storeOpsTitle;
  }

  /**
   * Set Store Ops Title Data
   * @param title
   * @returns void
   */
  public setStoreOpsTitle(title: string): void {
    this.storeOpsTitle = title;
    this.storeDataChangeNotifier.emit({ id: 'titleChange' });
  }

  /**
   * get Store Operations Content
   * @returns Observable
   */
  public getStoreOperationsContent(): Observable<object> {
    return this.contentProviderService.getContentData(CONTENT_ENDPOINT.STORE_OPS);
  }

  /**
   * To post Open Till Data
   * @param params
   */
  public postOpenTill(params: { [name: string]: string }): Observable<object> {
    const headers = new HttpHeaders();
    const openPosParams = {
      storeId: this.getStoreId(),
    };
    this.openPOsTillObject = {
      status: 'open',
      balance: Number(params.amount),
      businessDateTime: this.getStoreOpenDateTime(),
      tillType: params.tillType,
      macAddress: localStorage.getItem('macAddress') || this.getMacAddress(),
      barCode: params.id || this.getPOSTillId(),
      terminalId: params.id || this.getPOSTillId(),
    };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2707_openRetailStoresTill,
        this.openPOsTillObject,
        headers,
        null,
        openPosParams
      )
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * To navigate
   * @param route
   * @returns void
   */
  public navigate(route: string): void {
    this.router.navigate([route]);
  }

  /**
   * To get End Of Day Balance Data
   * @returns Observable
   */
  public getEndOfDayBalanceData(): Observable<boolean> {
    this.payLoadData = {
      tillId: this.getPOSTillId(),
      terminalId: this.storeOpsData.terminals[0].id,
      businessDateTime: moment(new Date()).format('YYYY-MM-DDThh:mm:ssZ'),
    };
    const headers = new HttpHeaders();
    const storeParams = {
      storeId: this.getStoreId(),
    };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2709_endOfDayBalance,
        this.payLoadData,
        headers,
        null,
        storeParams
      )
      .pipe(
        map((response: HttpResponse<PosConfirmation>) => {
          const data = response.body;
          return this.processEndOfDayBalance(data);
        })
      );
  }

  /**
   * To get End Of Day Balance Mobility Data
   * @returns Observable
   */
  public getEndOfDayBalanceMobilityData(): Observable<boolean> {
    this.payLoadMobilityData = {
      barcodeId: this.getPOSTillId(),
      businessDateTime: moment(new Date()).format('YYYY-MM-DDThh:mm:ssZ'),
    };
    const headers = new HttpHeaders();
    const storeParams = {
      storeId: this.getStoreId(),
    };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2709_endOfDayBalance,
        this.payLoadMobilityData,
        headers,
        null,
        storeParams
      )
      .pipe(
        map((response: HttpResponse<PosConfirmation>) => {
          const data = response.body;
          return this.processEndOfDayBalance(data);
        })
      );
  }

  /**
   * To close POSTill
   * @param params
   * @returns Observable
   */
  public closePOSTill(params?: { [name: string]: string }): Observable<Object> {
    this.closeTillPayLoad = {
      status: 'closed',
      tillType: 'POSTILL',
      businessDateTime: this.storeOpsData.storeOpenDateTime,
      cash: {
        backendBalance: this.closePOSTillData.cash,
        overShort: this.overshortCash,
      },
      corporateRefunds: {
        backendBalance: this.closePOSTillData.totalCorporateRefunds,
        overShort: this.overshortRefunds,
      },
      terminalId: this.storeOpsData.terminals[0].id,
      tillId: this.getPOSTillId(),
    };
    const headers = new HttpHeaders();
    const storeParams = {
      storeId: this.getStoreId(),
    };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2708_closeRetailStoresTill,
        this.closeTillPayLoad,
        headers,
        null,
        storeParams
      )
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        })
      );
  }

  /**
   * To close Mobility Till Data
   * @param params
   * @returns Observable
   */
  public closeMobilityTill(params: { [name: string]: string }): Observable<Object> {
    this.openCloseTillPayLoad = {
      barCode: params.barCode,
      status: 'closed',
      tillType: 'MOBILITYTILL',
      businessDateTime: this.storeOpsData.storeOpenDateTime,
      cash: {
        backendBalance: this.closePOSTillData.cash,
        overShort: this.overshortCash,
      },
      corporateRefunds: {
        backendBalance: this.closePOSTillData.totalCorporateRefunds,
        overShort: this.overshortRefunds,
      },
      terminalId: this.storeOpsData.terminals[0].id,
      tillId: this.getPOSTillId(),
    };

    const headers = new HttpHeaders();
    const storeParams = {
      storeId: this.getStoreId(),
    };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2708_closeRetailStoresTill,
        this.openCloseTillPayLoad,
        headers,
        null,
        storeParams
      )
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        })
      );
  }

  /**
   * To openStore
   * @returns Observable
   */
  public openStore(): Observable<object> {
    const headers = new HttpHeaders();
    const requestData = {
      status: 'open',
      currentDate: moment().format(),
    };
    const pathParams: { [name: string]: string } = { storeId: this.getStoreId() };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2711_openRetailStores,
        requestData,
        headers,
        null,
        pathParams
      )
      .pipe(
        map((response: HttpResponse<KeyValueMap>) => {
          const openStoreResult: KeyValueMap = response.body;
          this.setStoreId(<string>openStoreResult.storeId);
          this.setStoreStatus(openStoreResult.status === 'open');
          this.setStoreOpenDateTime(<string>openStoreResult.openedDateTime);
          return response.body;
        })
      );
  }

  /**
   * To openStore
   * @returns Observable
   */
  public closeStore(): Observable<object> {
    const headers = new HttpHeaders();
    const requestData = {
      status: 'closed',
      currentDate: moment().format(),
      forceClose: false,
      storeOpenDateTime: this.storeOpenDateTime,
    };
    const pathParams: { [name: string]: string } = { storeId: this.storeOpsData.id };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2710_closeRetailStores,
        requestData,
        headers,
        null,
        pathParams
      )
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        })
      );
  }

  /**
   * Get StoreDetails
   * @returns Observable
   */
  public getStoreDetails(isCached?: boolean): Observable<boolean> {
    const observable: Observable<boolean> = new Observable<boolean>(
      (subscriber: Subscriber<boolean>) => {
        this.setStoreDetails(isCached)
          .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
          .subscribe((storeDetilsResult: boolean) => {
            if (this.willAutomaticallyOpenPOSTill(true)) {
              this.postOpenTill({ tillType: 'POSTILL', amount: '0.00' })
                .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
                .subscribe((openTillConfirmation: ConfirmationData) => {
                  this.setStoreDetails(isCached)
                    .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
                    .subscribe((storeDetilsResult: boolean) => {
                      subscriber.next(storeDetilsResult);
                    });
                });
            } else {
              subscriber.next(storeDetilsResult);
            }
          });
      }
    );
    return observable;
  }

  /**
   * Get StoreDetails
   * @returns Observable
   */
  private setStoreDetails(isCached?: boolean): Observable<boolean> {
    const queryParams = {
      // @TODO Getting from localStorgae instead of stateStore to unblock QA testing
      macAddress: localStorage.getItem('macAddress') || this.stateStoreUtilsService.getMacAddress(),
    };
    const timestamp = new Date().getTime();
    const headers = new HttpHeaders().append('ui_timestamp', timestamp.toString());
    return this.apiGateway
      .getRequest(ASSISTED_API_MAP.API_2700_getRetailStores, headers, queryParams, null, isCached)
      .pipe(
        map((response: HttpResponse<Object>) => {
          this.storeOpsData = response.body;
          if (this.storeOpsData.macAddress) {
            this.setMacAddress(this.storeOpsData.macAddress);
          }
          this.setStoreId(this.storeOpsData.id);
          this.setStoreStatus(this.storeOpsData.status === 'Open');
          this.setStoreCapabiities(this.storeOpsData.storeCapabilities);
          this.islocationTypeMobileTruck = this.storeOpsData.locationType !== '';
          this.storeDataChangeNotifier.emit({ id: 'locationType' });
          this.setStoreOpenDateTime(this.storeOpsData.storeOpenDateTime);
          const isStoreRIS = this.objectService.get(this.storeOpsData, 'isStoreRIS');
          this.setRISStoreStatus(isStoreRIS);
          if (isStoreRIS) {
            this.setSerializationData();
          }
          this.stateStoreUtilsService.setStoreData(response.body);
          this.openedTills = this.storeOpsData.tills.filter((till: Till) => {
            return till.status === STORE_OPS_CONSTANTS.Open;
          });
          this.closedTills = this.storeOpsData.tills.filter((till: Till) => {
            return till.status === STORE_OPS_CONSTANTS.Closed;
          });
          this.setCashDrawers(this.openedTills, this.storeOpsData.hybrid);
          if (this.storeOpsData.terminals && this.storeOpsData.terminals.length > 0) {
            this.setTerminalData(this.storeOpsData.terminals[0]);
          }
          if (this.storeOpsData.tills && this.storeOpsData.tills.length > 0) {
            this.setMobilityTillData(this.storeOpsData.tills);
          }
          this.setMobilityTillOpenStatus(true);
          if (
            this.islocationTypeMobileTruck &&
            this.storeOpsData.status === STORE_OPS_CONSTANTS.Open
          ) {
            this.getTempStoreAddress(this.storeOpsData.id).subscribe(
              (result: GetTempStoreAddressResponse) => {
                this.updateStoreAddress(result);
              },
              (error: APIError) => {
                return false;
              }
            );
          }
          return false;
        })
      );
  }

  /**
   * update Address from gettemp store API
   * @returns StoreData
   */
  private updateStoreAddress(response: GetTempStoreAddressResponse): void {
    this.storeOpsData.address.line1 = response.address1;
    this.storeOpsData.address.line2 = response.address2;
    this.storeOpsData.address.city = response.city;
    this.storeOpsData.address.state = response.state;
    this.storeOpsData.address.phoneNumber = response.phoneNumber;
    this.stateStoreUtilsService.setStoreData(this.storeOpsData);
  }

  /**
   * Get Store Ops Data
   * @returns StoreData
   */
  public getStoreOpsData(): StoreData {
    return this.storeOpsData;
  }

  /**
   * Method is used to fetch store/tills data  by calling API_225, to check device is connected
   * @returns StoreData
   */
  public getStoreData(): Observable<StoreData> {
    const queryParams = {
      macAddress: this.stateStoreUtilsService.getMacAddress(),
    };
    const timestamp = new Date().getTime();
    const headers = new HttpHeaders().append('ui_timestamp', timestamp.toString());
    return this.apiGateway
      .getRequest(ASSISTED_API_MAP.API_2700_getRetailStores, headers, queryParams, null)
      .pipe(
        map((response: HttpResponse<StoreData>) => {
          const storeOpsData = response.body;
          this.setStoreId(storeOpsData.id);
          return storeOpsData;
        })
      );
  }

  /**
   * Set Store Status Data
   * @param storeStatus
   * @returns void
   */
  public setStoreStatus(storeStatus: boolean): void {
    this.stateStoreUtilsService.setStoreStatus(storeStatus);
    this.storeDataChangeNotifier.emit({ id: 'storeStatus' });
  }

  /**
   * Get Store Status
   * @returns boolean
   *
   */
  public getStoreStatus(): boolean {
    return this.stateStoreUtilsService.getStoreStatus();
  }

  /**
   * To set StoreId
   * @param storeId
   * @returns void
   */
  public setStoreId(storeId: string): void {
    this.stateStoreUtilsService.setStoreId(storeId);
    this.storeDataChangeNotifier.emit({ id: 'storeId' });
    window.dispatchEvent(
      new CustomEvent(TEXT_CONSTANTS.CHANGE_STORE, {
        detail: {
          storeId: storeId,
        },
      })
    );
  }

  /**
   * Get StoreId
   * @returns string
   */
  public getStoreId(): string {
    return this.stateStoreUtilsService.getStoreId();
  }

  /**
   * To set RIS Store status
   * @param isStoreRIS
   * @returns void
   */
  public setRISStoreStatus(isStoreRIS: boolean): void {
    this.stateStoreUtilsService.setRISStoreState(isStoreRIS);
  }
  /**
   * Get RIS Store Status
   * @returns string
   */
  public getRISStoreStatus(): boolean {
    return this.stateStoreUtilsService.getRISStoreState();
  }

  /**
   * To set simSerialization
   * @param simSerialization
   * @returns void
   */
  public setSIMSerialization(simSerialization: string): void {
    this.stateStoreUtilsService.setSimSerialization(simSerialization);
  }
  /**
   * Get sim serialization
   * @returns string
   */
  public getSIMSerialization(): string {
    return this.stateStoreUtilsService.getSimSerialization();
  }

  /**
   * To set licensePlate
   * @param licensePlate
   * @returns void
   */
  public setLicensePlate(licensePlate: string): void {
    this.stateStoreUtilsService.setLicensePlate(licensePlate);
  }
  /**
   * Get store licensePlate
   * @returns string
   */
  public getLicensePlate(): string {
    return this.stateStoreUtilsService.getLicensePlate();
  }

  /**
   * set TerminalData
   * @param terminalData
   * @returns void
   */
  public setTerminalData(terminalData: Terminals): void {
    this.terminalData = terminalData;
    this.stateStoreUtilsService.setTerminalData(terminalData);
    if (this.terminalData.tills && this.terminalData.tills.length) {
      this.setPOSTillStatus(this.terminalData.tills[0].status === 'Open');
      this.setPOSTillId(this.terminalData.tills[0].id);
    }
    this.storeDataChangeNotifier.emit({ id: 'terminalData' });
  }

  /**
   * Get TerminalData
   * @returns Terminals
   */
  public getTerminalData(): Terminals {
    return this.terminalData;
  }

  /**
   * set POSTillId
   * @param id
   * @returns void
   */
  public setPOSTillId(id: string): void {
    this.stateStoreUtilsService.setPosTillId(id);
  }

  /**
   * get POSTillId
   * @returns string
   */
  public getPOSTillId(): string {
    return this.stateStoreUtilsService.getposTillId();
  }

  /**
   * set setPOSTillCashAmount
   * @param cashAmount
   * @returns void
   */
  public setPOSTillCashAmount(cashAmount: string): void {
    this.stateStoreUtilsService.setPOSTillCashAmount(cashAmount);
  }

  /**
   * get getPOSTillCashAmount
   * @returns string
   */
  public getPOSTillCashAmount(): string {
    return this.stateStoreUtilsService.getPOSTillCashAmount();
  }

  /**
   * set POSTillStatus
   * @param isPOSTillOpen
   * @returns void
   */
  public setPOSTillStatus(isPOSTillOpen: boolean): void {
    const virtualTillStatus =
      this.featureToggleUtilService.isVirtualTillEnabled() &&
      (this.openedTills.length > 0 ||
        this.closedTills.length > 0 ||
        this.storeOpsData.hybrid.length > 0)
        ? isPOSTillOpen && (this.openedTills.length > 0 || this.storeOpsData.hybrid.length > 0)
        : isPOSTillOpen;
    this.stateStoreUtilsService.setPOSVirtualTillStatus(virtualTillStatus);
    this.stateStoreUtilsService.setPOSTillStatus(isPOSTillOpen);
    this.storeDataChangeNotifier.emit({ id: 'isPOSTillOpen' });
    window.dispatchEvent(
      new CustomEvent(TEXT_CONSTANTS.TILL_STATUS, {
        detail: {
          tillOpenStatus: virtualTillStatus,
          type: 'change',
        },
      })
    );
  }

  /**
   * set Mobility Till Open Confirmation Data
   * @param data
   * @returns void
   */
  public setMobilityTillOpenConfirmationData(data: ConfirmationData): void {
    this.mobilityTillOpenData = data;
    this.storeDataChangeNotifier.emit({ id: 'mobilityTillOpenData' });
    this.getStoreDetails().subscribe((result: boolean) => {});
  }

  /**
   * get Mobility Till Open Comfirmation Data
   * @returns ConfirmationData
   */
  public getMobilityTillOpenComfirmationData(): ConfirmationData {
    return this.mobilityTillOpenData;
  }

  /**
   * set MobilityTill Data
   * @param mobilityTillData
   * @returns void
   */
  public setMobilityTillData(mobilityTillData: MobilityTill[]): void {
    this.mobilityTillData = mobilityTillData;
    this.storeDataChangeNotifier.emit({ id: 'mobilityTillData' });
  }

  /**
   * Get Mobility Till Data
   * @returns void
   */
  public getMobilityTillData(): MobilityTill[] {
    return this.mobilityTillData;
  }

  /**
   * get Mobility Till Open Status
   * @returns boolean
   */
  public getMobilityTillOpenStatus(): boolean {
    return this.isMobilityTillOpen;
  }

  /**
   * set Mobility Till Open Status
   * @param isMobilityTillOpen
   * @returns void
   */
  public setMobilityTillOpenStatus(isMobilityTillOpen: boolean): void {
    this.isMobilityTillOpen = isMobilityTillOpen;
    this.storeDataChangeNotifier.emit({ id: 'isMobilityTillOpen' });
    this.storeDataChangeNotifier.emit({ id: 'isPOSTillOpen' });
  }

  /**
   * To Create Mobility Till Dropdown
   * @param status
   * @returns SelectItem[]
   */
  public createMobilityTillDropdown(status: string): SelectItem[] {
    const mobilityTillDropdown = [];
    this.mobilityTillData.forEach((keyObject: MobilityTill, key: number) => {
      if (this.mobilityTillData[key].status === status) {
        mobilityTillDropdown.push({
          label: this.mobilityTillData[key].id,
          value: this.mobilityTillData[key].id,
        });
      }
    });
    return mobilityTillDropdown;
  }

  /**
   * To postTill Data
   * @param tillParams
   * @param amount
   * @param status
   * @param tillType
   * @returns string
   */
  public postTillData(
    tillParams: { [name: string]: string },
    amount: number,
    status: string,
    tillType: string
  ): Observable<Object> {
    const headers = new HttpHeaders();
    tillParams.storeId = this.storeDetails.id;
    this.tillDataObject = {
      status: status,
      balance: amount || 0,
      businessDateAndTime: this.storeDetails.storeOpenDateTime,
      tillType: tillType,
      macAddress: this.storeDetails.macAddress,
    };
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_227_postRetailStoresTill,
        this.tillDataObject,
        headers,
        null,
        tillParams
      )
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        })
      );
  }

  /**
   * Get POS Till Status
   * @returns boolean
   */
  private getPOSTillStatus(): boolean {
    return this.stateStoreUtilsService.getPOSTillStatus();
  }

  /**
   * Set CorporateRefunds
   * @param corporateRefunds
   * @returns void
   */
  public setCorporateRefunds(corporateRefunds: string[]): void {
    this.corporateRefunds = corporateRefunds;
  }

  /**
   * get Corporate Refunds
   * @returns string[]
   */
  public getCorporateRefunds(): string[] {
    return this.corporateRefunds;
  }

  /**
   * set Close POSTill Data
   * @param cash
   * @param totalCorporateFunds
   * @returns void
   */
  public setClosePOSTillData(cash: string, totalCorporateFunds: number): void {
    this.closePOSTillData.cash = parseFloat(cash) || 0;
    this.closePOSTillData.totalCorporateRefunds = totalCorporateFunds || 0;
  }

  /**
   * get Close POSTill Data
   * @returns ClosePOSTillData
   */
  public getClosePOSTillData(): ClosePOSTillData {
    return this.closePOSTillData;
  }

  /**
   * get Cash Variance Status
   * @returns boolean
   */
  public getCashVarianceStatus(): boolean {
    return this.cashVariance;
  }

  /**
   * get Refund Variance Status
   * @returns boolean
   */
  public getRefundVarianceStatus(): boolean {
    return this.refundVariance;
  }

  /**
   * reset Out Of Balance Count
   * @returns void
   */
  public resetOutOfBalanceCount(): void {
    this.outofBalanceCount = 0;
  }

  /**
   * To increment Out Of Balance Count
   * @returns void
   */
  public incrementOutOfBalanceCount(): void {
    this.outofBalanceCount++;
  }

  /**
   * Get Out Of Balance Count
   * @returns number
   */
  public getOutOfBalanceCount(): number {
    return this.outofBalanceCount;
  }

  /**
   * set Store Open Date Time
   * @param storeOpenDateTime
   * @returns void
   */
  public setStoreOpenDateTime(storeOpenDateTime: string): void {
    this.storeOpenDateTime = storeOpenDateTime;
  }

  /**
   * get Store Open Date Time
   * @returns string
   */
  public getStoreOpenDateTime(): string {
    return this.storeOpenDateTime;
  }

  /**
   * set Mac Address
   * @param macAddress
   * @returns void
   */
  public setMacAddress(macAddress: string): void {
    this.stateStoreUtilsService.setMacAddress(macAddress);
  }

  /**
   * get Mac Address
   * @returns string
   */
  public getMacAddress(): string {
    return this.stateStoreUtilsService.getMacAddress();
  }

  /**
   * set POSCash Error
   * @param cashErrorObject
   * @returns void
   */
  public setPOSCashError(cashErrorObject: POSCashError): void {
    this.posCashErrorObject = cashErrorObject;
  }

  /**
   * get POSCashError
   * @returns POSCashError
   */
  public getPOSCashError(): POSCashError {
    return this.posCashErrorObject;
  }

  /**
   * set POSTill Open Confirmation Data
   * @param posTillOpenConfirmationData
   * @returns void
   */
  public setPOSTillOpenConfirmationData(posTillOpenConfirmationData: ConfirmationData): void {
    this.posTillOpenConfirmationData = posTillOpenConfirmationData;
  }

  /**
   * get POSTill Open Confirmation Data
   * @returns ConfirmationData
   */
  public getPOSTillOpenConfirmationData(): ConfirmationData {
    return this.posTillOpenConfirmationData;
  }

  /**
   * Gets reasons of dropdown for No Sale
   * @param type
   * @returns Observable
   */
  public getNoSaleReason(type: { [key: string]: string }): Observable<Object> {
    const headers = new HttpHeaders();
    return this.apiGateway
      .getRequest(ASSISTED_API_MAP.API_326_getAdjustmentReasons, headers, type)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        })
      );
  }

  /**
   * Posts No Sale Transaction
   * @param code
   * @returns Observable
   */
  public postNoSale(code: string, selectedIotCashDrawerId?: string): Observable<Object> {
    const headers = new HttpHeaders().append(
      STORE_OPS_CONSTANTS.TRANSACTION_ID,
      this.storeOpsData.terminals[0].id
    );
    const param = {
      storeId: this.getStoreId(),
    };
    const reason = {
      code: code,
    };
    const data = {
      terminalId: this.storeOpsData.terminals[0].id,
      tillId: this.getPOSTillId(),
      businessDateTime: this.storeOpsData.storeOpenDateTime,
      currentDateTime: new Date(),
      reason: reason,
    };
    return this.apiGateway
      .postRequest(ASSISTED_API_MAP.API_2712_postNoSale, data, headers, null, param)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        })
      );
  }

  /**
   * To format Amount
   * @param amount
   * @returns string
   */
  public formatAmount(amount: string): string {
    if (amount.match(/[0-9][.][0-9][0-9]/g)) {
      return '$' + amount;
    } else {
      return '$' + amount + '.00';
    }
  }

  /**
   * To format Date
   * @param date
   * @param format
   * @returns string
   */
  public formatDate(date: string, format: string): string {
    return moment(date).format(format);
  }

  /**
   * Method for getting field Validation constants
   * @return ObjectInterface
   */
  public getFieldValidationConstants(): ObjectInterface {
    return this.commonApiService.getFieldValidationConstants();
  }

  /**
   * Used to check whether chip is enabled or not
   */
  public checkEmvEnabled(): Observable<boolean> {
    /**
      if (this.stateStoreUtilsService.isTapestry()) {
        const isEMVChipEnabled = sessionStorage.getItem('Infinea.Scanner.emvChipEnabled') !== 'false';
        return observableOf(isEMVChipEnabled);
      } else {
        return this.ingenicoService.isChipEnabled()
          .pipe(map((isEmvEnabled: boolean) => {
            return isEmvEnabled;
          }));
      }
    } else {
      return observableOf(false);
    }
    */
    // Commented method for Web to remove dependency of Ingenico in cart-support.service <- store.service and return observableOf(false)
    return observableOf(false);
  }

  /**
   * Used to check whether store is enabled or not for EMV
   */
  public checkStoreEmvEnabled(): boolean {
    const storeData = this.stateStoreUtilsService.getStoreData();
    return (
      storeData &&
      storeData.isStoreDigital &&
      ((this.stateStoreUtilsService.isTapestry() && storeData.tapestryEMVEnabled) ||
        (!this.stateStoreUtilsService.isTapestry() && storeData.desktopEMVEnabled))
    );
  }

  /**
   * Method is used to open HybridCashDrawer by calling API_2702, if bar code is not in API_2701
   * @param barCode is of type string , barCode fetched from API_2701.
   * @param mobilityTill is of type booelan .
   * @returns HybridCashDrawerResponse
   */
  public openHybridCashDrawer(
    barCode: string,
    mobilityTill?: boolean,
    userFriendlyMessage?: string
  ): Observable<HybridCashDrawerResponse> {
    const barcodeData = {
      barcode: barCode,
      macAddress: this.stateStoreUtilsService.getMacAddress(),
    };
    const apiURL = ASSISTED_API_MAP.API_2702_postOpenCashDrawer;
    return this.apiGateway
      .postRequest(apiURL, barcodeData, null, null, null, null, true, userFriendlyMessage)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * To process End Of Day Balance
   * @param data
   * @returns boolean
   */
  private processEndOfDayBalance(data: PosConfirmation): boolean {
    const overshortCashValue =
      this.getClosePOSTillData().cash -
      (parseFloat(data.cash.systemBalance) + parseFloat(data.loanAmount));
    this.overshortCash = this.roundToCents(overshortCashValue);
    this.cashVariance = !this.checkTolerance(this.overshortCash, data.cash.tolerance);
    if (data.corporateRefunds) {
      const overshortRefundsValue =
        this.getClosePOSTillData().totalCorporateRefunds -
        parseFloat(data.corporateRefunds.systemBalance);
      this.overshortRefunds = this.roundToCents(overshortRefundsValue);
      this.refundVariance = !this.checkTolerance(
        this.overshortRefunds,
        data.corporateRefunds.tolerance
      );
    }
    this.inBalance = !this.cashVariance && !this.refundVariance;
    return this.inBalance;
  }

  /**
   * For round to nearest cent overShortValue
   * @param value
   * @param decimals
   * @returns number
   */
  private roundToCents(value: number): number {
    return Number(`${Math.round(parseFloat(`${value}e2`))}e-2`);
  }

  /**
   * To check Tolerance
   * @param overshort
   * @param tolerance
   * @returns boolean
   */
  private checkTolerance(overshort: number, tolerance: number): boolean {
    return Math.abs(overshort) <= tolerance;
  }

  /**
   * To get Serialization Info when Store id RIS enabeled
   */
  private getSerializationInfo(): Observable<SerializationResponse> {
    const headers = new HttpHeaders();
    return this.apiGateway
      .getRequest(API_MAP.API_2149_getSerializationInfo, headers, null, null)
      .pipe(
        map((response: HttpResponse<Object>) => {
          const res: SerializationResponse = response.body;
          return res;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  private setSerializationData(): void {
    this.getSerializationInfo().subscribe(
      (res: SerializationResponse) => {
        const simSerialization = this.objectService.get(res, 'result.simSerialization');
        const licensePlate = this.objectService.get(res, 'result.licensePlate');
        if (simSerialization) {
          this.setSIMSerialization(simSerialization);
        }
        if (licensePlate) {
          this.setLicensePlate(licensePlate);
        }
      },
      (error: APIError) => {}
    );
  }

  /**
   * Validate the zip code
   * @param type
   * @returns Observable
   */
  public zipCodeValidation(zipCode: string): Observable<Object> {
    const headers = new Headers();
    const param = {
      postalCode: zipCode,
    };
    return this.apiGateway
      .postRequest(API_MAP.API_2004_addressValidation, param, null, null, null)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * Validate the complete address
   * @param type
   * @returns Observable
   */
  public addressValidation(param: AddressValidationRequest): Observable<Object> {
    this.setAddressFormData = param;
    return this.apiGateway
      .postRequest(API_MAP.API_2004_addressValidation, param, null, null, null)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * Set the temporary address
   * @param type
   * @returns Observable
   */
  public setTempStoreAddress(param: object): Observable<Object> {
    const timestamp = new Date().getTime();
    const headers = new HttpHeaders().append('ui_timestamp', timestamp.toString());
    return this.apiGateway
      .postRequest(ASSISTED_API_MAP.API_2718_setTempStoreAddress, param, headers, null, null)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * get the temporary address
   * @param type
   * @returns Observable
   */
  public getTempStoreAddress(storeId: string): Observable<Object> {
    const queryParams = {
      storeId: storeId,
    };
    const timestamp = new Date().getTime();
    const headers = new HttpHeaders().append('ui_timestamp', timestamp.toString());
    return this.apiGateway
      .getRequest(ASSISTED_API_MAP.API_2717_getTempStoreAddress, headers, queryParams, null, null)
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * update the temporary address status in pos
   * @param type
   * @returns Observable
   */
  public updateTempStoreAddress(): Observable<Object> {
    const params = {
      storeId: this.getStoreId(),
      addrStatus: 'INACTIVE',
    };
    const timestamp = new Date().getTime();
    const headers = new HttpHeaders().append('ui_timestamp', timestamp.toString());
    return this.apiGateway
      .postRequest(
        ASSISTED_API_MAP.API_2719_updateTempStoreAddressStatus,
        params,
        headers,
        null,
        null
      )
      .pipe(
        map((response: HttpResponse<Object>) => {
          return response.body;
        }),
        catchError((error: APIError[]) => {
          return observableThrowError(error);
        })
      );
  }

  /**
   * close the tool slider.
   * @param type
   * @returns void
   */
  public closeToolBar(): void {
    window.dispatchEvent(new CustomEvent(TEXT_CONSTANTS.CLOSE_TOOL_SLIDER, {}));
  }

  /**
   * set cash drawer
   * @param type
   * @returns void
   */
  private setCashDrawers(openTills: Till[], hybrid: Till[]): void {
    const allTills = openTills.concat(hybrid);
    const cashDrawers: string[] = [];
    for (const till of allTills) {
      cashDrawers.push(till.id);
    }
    this.networkCashDrawers = cashDrawers;
  }

  /**
   * get cash drawer
   * @param type
   * @returns void
   */
  public getCashDrawers(): string[] {
    return this.networkCashDrawers;
  }

  private getStoreCapability(capability: string): string {
    if (this.storeCapabilities.hasOwnProperty(capability)) {
      return this.storeCapabilities[capability];
    }
    return null;
  }

  private setVirtualTillFeatureOverride(): void {
    const virtualTillCapability = this.getStoreCapability('IS_DSKT_TILL_PILOT');
    const virtualTillOverride = virtualTillCapability ? virtualTillCapability === 'Y' : null;
    this.featureToggleUtilService.setVirtualTillOverride(virtualTillOverride);
  }

  private setStoreCapabiities(storeCapabilities: Capability[] = []): void {
    this.storeCapabilities = {};
    for (const capability of storeCapabilities) {
      this.storeCapabilities[capability.name] = capability.value;
    }
    this.setVirtualTillFeatureOverride();
  }

  public willAutomaticallyOpenPOSTill(openTillFlow: boolean): boolean {
    return (
      this.isVirtualTillEnabled() &&
      this.openedTills.length > 0 &&
      (openTillFlow
        ? !this.stateStoreUtilsService.getPOSTillStatus()
        : this.stateStoreUtilsService.getPOSTillStatus())
    );
  }

  public isVirtualTillEnabled(): boolean {
    return (
      (this.storeOpsData.tills.length > 0 || this.storeOpsData.hybrid.length > 0) &&
      !this.stateStoreUtilsService.isTapestry() &&
      this.featureToggleUtilService.isVirtualTillEnabled()
    );
  }
}
